import React from "react";

export default function StepsSection({ title, subtitle, steps }) {
  return (
    <section className="steps-section p-2">
      <div className="container">
        <div className="section-header text-center">
          <h2 className="subtitle">{subtitle}</h2>
          <p className="title">{title}</p>
        </div>
        <div className="row">
          {steps.map((step, index) => (
            <div key={index} className="col-lg-3 col-md-6 col-sm-12 mb-4">
              <div className="step-card">
                <div className="step-icon">
                  <i className={step.icon}></i>
                </div>
                <h4 className="step-title">{step.title}</h4>
                <p className="step-description">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}